import { render } from "./VitrinePrix.vue?vue&type=template&id=a86d03fa"
import script from "./VitrinePrix.vue?vue&type=script&lang=js"
export * from "./VitrinePrix.vue?vue&type=script&lang=js"

import "./VitrinePrix.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__